<template>
  <div
    @click="onClick"
    data-testid="vcita-date-range-title"
    class="vcita-date-range-title"
    tabindex="0">
    <span v-if="label" class="label-span ma-1 pa-1">
      {{label}}
    </span>
    <span class="date-range-span ma-1 mx-1">
      {{$t(dateRangeKey,{'startDay': formatDates.startDate.day, 'startMonth': formatDates.startDate.month, 'startYear': formatDates.startDate.year, 'endDay': formatDates.endDate.day, 'endMonth': formatDates.endDate.month, 'endYear': formatDates.endDate.year })}}
    </span>
  </div>
</template>

<script>
export default {
  name: "VcitaDateRangeTitle",
  props:{
    startDate:{
      type: Object,
      required: true,
    },
    endDate:{
      type: Object,
      required: true,
    },
    label:{
      type: String,
      required: false
    },
    dateRangeKey:{
      type: String,
      required: true
    }
  },
  computed:{
    formatDates(){
      let date = {
        startDate:{},
        endDate:{}
      }
      date.endDate['day'] = this.endDate.format('D')
      date.endDate['month'] = this.endDate.format('MMM')
      date.endDate['year'] = this.endDate.format('YYYY')
      date.startDate['day'] = this.startDate.format('D');
      date.startDate['month'] = this.startDate.format('MMM')
      date.startDate['year'] = this.startDate.format('YYYY')
      return date;
    }
  },
  methods:{
    onClick(e){
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/abstract/_i18n-mixins';
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.vcita-date-range-title{
  user-select: none;
  display: inline-block;
  font-family: var(--primary-font-family);
  font-style: normal;
  font-weight: 500;
  border-radius: 4px;
  text-align: center;
  align-items: baseline;
  background-color: $white-color-1;
  @include md-and-up{
    height: 36px;
    line-height: 36px;
  }
  @include sm-and-down{
    height: 32px;
    line-height: 32px;
  }

  &:hover{
    background-color: rgba(0,0,0,0.07);
    border-color: rgba(0, 0, 0, 0.07);

    .label-span{
      background: rgba(0, 0, 0, 0.07);
    }
  }

  &:active{
    background-color: rgba(0, 0, 0, 0.2);
    border-color: rgba(0, 0, 0, 0.2);
    box-shadow: none;
    .label-span{
      background: rgba(0, 0, 0, 0.03);
    }
  }
  &:focus-visible{
    @include md-and-up {
      box-shadow: 0px 0px 0px 3px rgba(var(--brand-color-secondary-rgb), 0.36);
      outline: none;
    }
    @include sm-and-down {
      box-shadow: none;
      outline: none;
    }
  }
  &:active:focus{
    outline: none;
    box-shadow: none;
  }
  .date-range-span{
    text-align: center;
    color: $black-color-2;
    @include md-and-up{
      height: 28px;
      font-size: 18px;
      line-height: 28px;
    }
    @include sm-and-down{
      height: 20px;
      font-size: 15px;
      line-height: 20px;
    }
  }

  .label-span{
    background: rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.62);
    font-size: 12px;
    line-height: 16px;
    height: 16px;
  }
}
</style>
